export enum SequenceScheduleDaysModeEnum {
  BusinessDays = 'BUSINESS_DAYS',
  AnyDay = 'ANY_DAY',
}
